import { NwButton } from "@nawy/ui";
import useTelephoneActions from "@/modules/lead-page/new/hooks/telephone-actions.hook";
import useTelephoneConfig from "@/modules/lead-page/new/hooks/telephone-config.hook";
import {
  Box,
  CircularProgress,
  Collapse,
  Typography,
  useTheme,
} from "@mui/material";
import { MuiTelInput } from "mui-tel-input";
import CloseIcon from "@mui/icons-material/Close";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import PrimaryNumber from "@/modules/lead-page/new/components/sidebar/fields/telephone/primary-number";
import OtherNumbers from "@/modules/lead-page/new/components/sidebar/fields/telephone/other-numbers";
import { useTelephoneContext } from "@/modules/lead-page/new/hooks/telephone-context.hook";

const TelephoneModal = () => {
  const theme = useTheme();

  const { hasMoreThanOneTelephone } = useTelephoneConfig();

  const {
    showAddTelephoneInput,
    handleToggleAddForm,
    handleAddTelephone,
    handlePhoneChange,
  } = useTelephoneActions();

  const { telephone } = useTelephoneContext();

  const telephoneHook = telephone;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: theme.nawy.spacing.md,
        padding: theme.nawy.spacing.md,
        borderRadius: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: theme.nawy.spacing.md,
        }}
      >
        <PrimaryNumber />

        {hasMoreThanOneTelephone && <OtherNumbers />}

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          {!showAddTelephoneInput && (
            <Box sx={{ width: "fit-content" }}>
              <NwButton
                variant="text"
                sx={{
                  paddingX: 0,
                  width: "fit-content",
                }}
                onClick={handleToggleAddForm}
                startIcon={
                  showAddTelephoneInput ? (
                    <CloseIcon width={16} height={16} />
                  ) : (
                    <AddOutlinedIcon width={16} height={16} />
                  )
                }
              >
                Add number
              </NwButton>
            </Box>
          )}

          <Collapse in={showAddTelephoneInput} timeout={300}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                gap: theme.nawy.spacing.md,
              }}
            >
              {/* Header with icon and label */}

              {/* Phone input field */}
              <Box sx={{ width: "100%" }}>
                <Typography
                  component="span"
                  sx={{
                    ...theme.nawy.typography.english.variants.body.xs.regular,
                    color: theme.palette.text.secondary,
                  }}
                >
                  Add number
                </Typography>
                <MuiTelInput
                  value={telephoneHook.state}
                  defaultCountry="EG"
                  onChange={(value, info) => {
                    handlePhoneChange(value, info);
                  }}
                  fullWidth
                  size="small"
                  placeholder="Enter Phone Number"
                />
              </Box>

              {/* Action buttons */}
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  justifyContent: "flex-end",
                }}
              >
                <NwButton
                  variant="outlined"
                  color="secondary"
                  onClick={handleToggleAddForm}
                  sx={{
                    width: "100%",
                  }}
                >
                  Cancel
                </NwButton>
                <NwButton
                  disabled={
                    telephoneHook.addTelephone.isAddingTelephone ||
                    telephoneHook.state === "" ||
                    telephoneHook.addTelephone.addTelephoneValidationError
                      .length > 0
                  }
                  onClick={handleAddTelephone}
                  sx={{
                    width: "100%",
                  }}
                >
                  {telephoneHook.addTelephone.isAddingTelephone ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : (
                    "Save"
                  )}
                </NwButton>
              </Box>
            </Box>
          </Collapse>
        </Box>
      </Box>
    </Box>
  );
};

export default TelephoneModal;
